// /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// // /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// // // /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// // // /* eslint-disable consistent-return */
// // // import React, { useEffect, useState, useCallback, useRef } from 'react';
// // // import { useLocation } from 'react-router-dom';
// // // import { toast } from 'react-toastify';
// // // import {
// // //   MdTableRows,
// // //   MdImage,
// // //   MdSchema,
// // //   MdChevronLeft,
// // //   MdChevronRight,
// // //   MdFullscreen,
// // //   MdFullscreenExit,
// // // } from 'react-icons/md';

// // // import api from '../../services/api';
// // // import history from '../../services/history';

// // // import { AppError } from '../../errors/AppError';
// // // import { opPaginaCatalogoSituacao } from '../../lib/const';

// // // import TitleBar from '../../components/TitleBar';
// // // import EditorArea from '../../components/EditorAI/index';
// // // import EditorTable from '../../components/EditorAI/Table/index';
// // // import Pagination from '../../components/EditorAI/Pagination';
// // // import Switch from '../../components/Form/Input/Switch';

// // // import { Form } from '../../components/Form';
// // // import Input from '../../components/Form/Input';
// // // import Loading from '../../components/Loading';

// // // import { EditorContainer } from '../../components/Container/index';

// // // import { Action } from './styles';

// // // function EditorAssociarAI() {
// // //   const location = useLocation();
// // //   const { id, paginaInicial = 0 } = location.state;

// // //   const editorRef = useRef();
// // //   const tableRef = useRef();
// // //   const formRef = useRef();
// // //   const formPesqRef = useRef();

// // //   // refs/estado para layout
// // //   const layoutRef = useRef(null);
// // //   const [sidebarWidth, setSidebarWidth] = useState(380);
// // //   const [isResizing, setIsResizing] = useState(false);

// // //   /**
// // //    * ===================================================================
// // //    * ÁREA DE TRABALHO
// // //    * -------------------------------------------------------------------
// // //    * Dois controles para o desenho ganhar tela:
// // //    *
// // //    *  - painelAberto: recolhe o painel de itens para um trilho estreito,
// // //    *    devolvendo a largura inteira ao desenho sem perder o acesso à
// // //    *    tabela (um clique traz de volta, na mesma largura).
// // //    *
// // //    *  - modoAmplo: o editor passa a ocupar a janela toda, por cima do
// // //    *    header e do rodapé da aplicação. Sai por Esc ou pelo botão.
// // //    * ===================================================================
// // //    */
// // //   const [painelAberto, setPainelAberto] = useState(true);
// // //   const [modoAmplo, setModoAmplo] = useState(false);

// // //   const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

// // //   const [catalogo, setCatalogo] = useState(null);
// // //   const [paginaCatalogo, setPaginaCatalogo] = useState(null);
// // //   const [itensPagina, setItensPagina] = useState([]);
// // //   const [itensFiltro, setItensFiltro] = useState([]);
// // //   const [linkedFiltro, setLinkedFiltro] = useState(false);
// // //   const [loading, setLoading] = useState(false);

// // //   /** controle de pesquisa */
// // //   const [search, setSearch] = useState();

// // //   /** controle de páginas */
// // //   const [currentPage, setCurrentPage] = useState(null);
// // //   const [totalPage, setTotalPage] = useState(0);

// // //   const carregaPagina = useCallback(async () => {
// // //     /** limpa variável de itens */
// // //     setItensPagina([]);
// // //     setItensFiltro([]);

// // //     /** limpa campo de pesquisa */
// // //     if (formPesqRef.current) {
// // //       formPesqRef.current.reset();
// // //     }

// // //     /** cancela operação se não houver catálogo e página para busca */
// // //     if (!(catalogo && currentPage)) return true;

// // //     const pagina = catalogo.paginas[currentPage - 1];

// // //     /** cancela operação se página não existir */
// // //     if (!pagina) return true;

// // //     setLoading(true);
// // //     try {
// // //       /** carrega itens da página */
// // //       const response = await api.get(`editor-associar/${id}/pagina/${pagina}`);
// // //       setPaginaCatalogo(response.data);

// // //       setItensPagina(() =>
// // //         response.data.itemPagina.map((item) => ({
// // //           ...item,
// // //           ...item.materialFabricante,
// // //           linked: false,
// // //           highlighted: false,
// // //           locked: false,
// // //         }))
// // //       );

// // //       setSearch('');
// // //     } finally {
// // //       setLoading(false);
// // //       if (editorRef.current) editorRef.current.getLinked();
// // //     }
// // //   }, [id, catalogo, currentPage]);

// // //   useEffect(() => {
// // //     /** informações do catálogo */
// // //     api.get(`editor-associar/${id}`).then((response) => {
// // //       const paginas = response.data.paginaCatalogo || [];

// // //       setPaginaCatalogo(null);

// // //       setCatalogo({
// // //         ...response.data,
// // //         paginas: paginas.map((pagina) => pagina.idPagina),
// // //       });

// // //       setTotalPage(response.data.total);

// // //       setCurrentPage(() => {
// // //         /** index da última página concluída do catálogo */
// // //         const lastIndex = Math.max(
// // //           ...paginas.reduce((acumuladoPagina, atualPagina, index) => {
// // //             // adiciona primeira página
// // //             if (
// // //               index === 0 ||
// // //               atualPagina.situacao === opPaginaCatalogoSituacao.CONCLUIDO
// // //             ) {
// // //               acumuladoPagina.push(index);
// // //             }

// // //             return acumuladoPagina;
// // //           }, [])
// // //         );

// // //         const lastDonePage = lastIndex + 1;

// // //         return paginaInicial || lastDonePage;
// // //       });
// // //     });
// // //   }, [id, paginaInicial]);

// // //   useEffect(() => {
// // //     carregaPagina();
// // //   }, [id, catalogo, currentPage, carregaPagina]);

// // //   const handleSalvar = useCallback(async ({ svg }) => {
// // //     const formData = new FormData();
// // //     formData.append('file', svg);

// // //     /** enviar o arquivo para o servidor e recebe o local em que ele foi armazenado */
// // //     const response = await api.post('files', formData);
// // //     const { path } = response.data;

// // //     formRef.current.setFieldValue('caminho', path);

// // //     formRef.current.submitForm();
// // //   }, []);

// // //   const handleCancelar = useCallback(async () => {
// // //     carregaPagina();
// // //   }, [carregaPagina]);

// // //   const handleConfirmar = useCallback(
// // //     async (data) => {
// // //       setLoading(true);
// // //       try {
// // //         const { caminho } = data;
// // //         const { idPagina } = paginaCatalogo;

// // //         /** envia todas as informações para serem persistidas */
// // //         await api.put(`editor-associar/${id}/pagina/${idPagina}`, {
// // //           caminho,
// // //         });

// // //         carregaPagina();

// // //         /** mensagem de sucesso */
// // //         toast.success('Página salva com sucesso!');
// // //       } catch (err) {
// // //         AppError(err, formRef);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     },
// // //     [id, paginaCatalogo, carregaPagina]
// // //   );

// // //   const handleFiltro = useCallback(
// // //     (searching, filtered) => {
// // //       setItensFiltro(() => {
// // //         let newValue = itensPagina;

// // //         if (filtered) newValue = newValue.filter((item) => !item.linked);

// // //         if (searching)
// // //           newValue = newValue.filter((item) =>
// // //             String(item.idItem)
// // //               .toUpperCase()
// // //               .startsWith(String(searching).toUpperCase())
// // //           );

// // //         return newValue;
// // //       });

// // //       setSearch(searching);
// // //       setLinkedFiltro(filtered);
// // //     },
// // //     [itensPagina]
// // //   );

// // //   const handlePesquisar = useCallback(
// // //     (e) => {
// // //       handleFiltro(e.target.value, linkedFiltro);
// // //     },
// // //     [linkedFiltro, handleFiltro]
// // //   );

// // //   const handleFiltrar = useCallback(() => {
// // //     handleFiltro(search, !linkedFiltro);
// // //   }, [search, linkedFiltro, handleFiltro]);

// // //   const handleLink = useCallback((itens) => {
// // //     const lockStates = tableRef.current ? tableRef.current.getLockStates() : [];

// // //     setItensPagina((old) =>
// // //       old.map((item) => {
// // //         const { locked } =
// // //           lockStates.find((link) => link.idItem === item.idItem) || false;

// // //         const linked = itens.includes(item.idItem);

// // //         return {
// // //           ...item,
// // //           linked,
// // //           highlighted: false,
// // //           locked: linked && locked,
// // //         };
// // //       })
// // //     );
// // //   }, []);

// // //   const handleHighlight = useCallback((links, component) => {
// // //     let ref = null;
// // //     switch (component) {
// // //       case 'table':
// // //         ref = editorRef.current;
// // //         break;
// // //       case 'editor':
// // //         ref = tableRef.current;
// // //         break;
// // //       default:
// // //         break;
// // //     }

// // //     if (ref) ref.highlightLinks(links);
// // //   }, []);

// // //   useEffect(
// // //     () => {
// // //       handleFiltro(search, linkedFiltro);
// // //     },
// // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // //     [handleFiltro]
// // //   );

// // //   /** redireciona para a referencia */
// // //   const handleNavegar = useCallback(
// // //     (param = 'isClassificar' || 'isExtrair' || 'isEditar') => {
// // //       const { idPagina } = paginaCatalogo || {};

// // //       if (!idPagina) {
// // //         throw new AppError('Referência não encontrada!');
// // //       }

// // //       try {
// // //         switch (param) {
// // //           case 'isClassificar':
// // //             history.replace(`/edicao/classificarAI`, {
// // //               id,
// // //               paginaInicial: idPagina,
// // //             });
// // //             break;
// // //           case 'isExtrair':
// // //             api.get(`editor-extrair/${id}`).then((response) => {
// // //               const paginaIndex = response.data.paginaCatalogo.findIndex(
// // //                 (pagina) => pagina.referencia === idPagina
// // //               );

// // //               if (paginaIndex === -1)
// // //                 throw new AppError(
// // //                   'Não há tabela com referência para esta página'
// // //                 );

// // //               history.replace(`/edicao/extrairAI`, {
// // //                 id,
// // //                 paginaInicial: paginaIndex + 1,
// // //               });
// // //             });
// // //             break;
// // //           case 'isEditar':
// // //             api.get(`editor-editar/${id}`).then((response) => {
// // //               const paginaIndex = response.data.paginaCatalogo.findIndex(
// // //                 (pagina) => pagina.idPagina === idPagina
// // //               );
// // //               history.replace(`/edicao/editarAI`, {
// // //                 id,
// // //                 paginaInicial: paginaIndex + 1,
// // //               });
// // //             });
// // //             break;
// // //           default:
// // //             break;
// // //         }
// // //       } catch (err) {
// // //         AppError(err);
// // //       }
// // //     },
// // //     [id, paginaCatalogo]
// // //   );

// // //   const handleVoltar = useCallback(() => {
// // //     history.replace('/edicao/editarAI', { id });
// // //   }, [id]);

// // //   /** ---- Layout: redimensionamento lateral ---- */
// // //   const onStartResize = useCallback((e) => {
// // //     e.preventDefault();
// // //     setIsResizing(true);
// // //   }, []);

// // //   useEffect(() => {
// // //     if (!isResizing) return;

// // //     const onMove = (e) => {
// // //       if (!layoutRef.current) return;
// // //       const rect = layoutRef.current.getBoundingClientRect();
// // //       const next = clamp(e.clientX - rect.left, 260, 640); // limites
// // //       setSidebarWidth(next);
// // //     };

// // //     const onUp = () => setIsResizing(false);

// // //     window.addEventListener('mousemove', onMove);
// // //     window.addEventListener('mouseup', onUp);
// // //     return () => {
// // //       window.removeEventListener('mousemove', onMove);
// // //       window.removeEventListener('mouseup', onUp);
// // //     };
// // //   }, [isResizing]);

// // //   /**
// // //    * Esc sai do modo amplo. Fica no window porque o foco costuma estar no
// // //    * desenho (que trata o próprio Esc para limpar a seleção) — por isso a
// // //    * checagem só sai do modo quando ele está ativo.
// // //    */
// // //   useEffect(() => {
// // //     if (!modoAmplo) return undefined;

// // //     const onEsc = (e) => {
// // //       if (e.key === 'Escape' || e.keyCode === 27) setModoAmplo(false);
// // //     };

// // //     window.addEventListener('keydown', onEsc);
// // //     return () => window.removeEventListener('keydown', onEsc);
// // //   }, [modoAmplo]);

// // //   /** ---- Derivados de status ---- */
// // //   const total = itensPagina.length;
// // //   const vinculados = itensPagina.filter((i) => i.linked).length;
// // //   const pendentes = total - vinculados;

// // //   return (
// // //     /**
// // //      * O teto de 1440px foi retirado: em monitor maior a largura sobrando
// // //      * ia para as margens em vez de ir para o desenho. No modo amplo o
// // //      * container sai do fluxo e cobre a janela inteira.
// // //      */
// // //     <EditorContainer
// // //       style={
// // //         modoAmplo
// // //           ? {
// // //               position: 'fixed',
// // //               top: 0,
// // //               left: 0,
// // //               right: 0,
// // //               bottom: 0,
// // //               zIndex: 60,
// // //               background: '#f2f5fc',
// // //               padding: 8,
// // //               margin: 0,
// // //               maxWidth: 'none',
// // //             }
// // //           : undefined
// // //       }
// // //     >
// // //       <TitleBar back onBack={() => handleVoltar()} title="Mapeamento">
// // //         <Action.BtnSquare
// // //           type="button"
// // //           title={
// // //             painelAberto
// // //               ? 'Recolher o painel de itens (mais espaço para o desenho)'
// // //               : 'Mostrar o painel de itens'
// // //           }
// // //           className="btn-nav-ref"
// // //           aria-pressed={!painelAberto}
// // //           onClick={() => setPainelAberto((atual) => !atual)}
// // //         >
// // //           {painelAberto ? (
// // //             <MdChevronLeft size={30} />
// // //           ) : (
// // //             <MdChevronRight size={30} />
// // //           )}
// // //         </Action.BtnSquare>
// // //         <Action.BtnSquare
// // //           type="button"
// // //           title={
// // //             modoAmplo
// // //               ? 'Sair do modo tela cheia (Esc)'
// // //               : 'Modo tela cheia: usa a janela inteira para o desenho'
// // //           }
// // //           className="btn-nav-ref"
// // //           aria-pressed={modoAmplo}
// // //           onClick={() => setModoAmplo((atual) => !atual)}
// // //         >
// // //           {modoAmplo ? (
// // //             <MdFullscreenExit size={30} />
// // //           ) : (
// // //             <MdFullscreen size={30} />
// // //           )}
// // //         </Action.BtnSquare>
// // //         <Action.BtnSquare
// // //           type="button"
// // //           title="Navegar para o processo de Classificação"
// // //           className="btn-nav-ref"
// // //           onClick={() => handleNavegar('isClassificar')}
// // //         >
// // //           <MdSchema size={30} />
// // //         </Action.BtnSquare>
// // //         <Action.BtnSquare
// // //           type="button"
// // //           title="Navegar para o processo de Extração"
// // //           className="btn-nav-ref"
// // //           onClick={() => handleNavegar('isExtrair')}
// // //         >
// // //           <MdTableRows size={30} />
// // //         </Action.BtnSquare>
// // //         <Action.BtnSquare
// // //           type="button"
// // //           title="Navegar para o processo de Edição"
// // //           className="btn-nav-ref"
// // //           onClick={() => handleNavegar('isEditar')}
// // //         >
// // //           <MdImage size={30} />
// // //         </Action.BtnSquare>
// // //       </TitleBar>

// // //       <Loading visible={loading} />

// // //       <EditorContainer.Wrapper>
// // //         {catalogo && (
// // //           <EditorContainer.EditorArea style={{ padding: 0 }}>
// // //             {/* Layout flex com barra de redimensionamento */}
// // //             <div
// // //               ref={layoutRef}
// // //               style={{
// // //                 display: 'flex',
// // //                 /**
// // //                  * Altura de viewport em vez de altura automática: antes a
// // //                  * área do desenho valia o tamanho intrínseco do SVG e
// // //                  * sobrava tela sem uso embaixo. As variáveis estão em
// // //                  * styles/global.js e já acompanham a densidade do tablet.
// // //                  */
// // //                 height: modoAmplo
// // //                   ? /** tela cheia: só descontam a barra de título e os recuos do cartão */
// // //                     'calc(100vh - var(--edt-titlebar-h) - (var(--edt-card-pad-y) * 2) - 16px)'
// // //                   : 'calc(100vh - var(--edt-chrome-h))',
// // //                 minHeight: 380,
// // //                 width: '100%',
// // //                 position: 'relative',
// // //               }}
// // //             >
// // //               {/**
// // //                * Painel lateral (controles + tabela).
// // //                * Recolhido, sai do layout por inteiro e o desenho recebe
// // //                * a largura toda; a largura ajustada pelo arraste é
// // //                * preservada para quando voltar.
// // //                */}
// // //               <div
// // //                 style={{
// // //                   flex: painelAberto
// // //                     ? `0 0 ${Math.round(sidebarWidth)}px`
// // //                     : '0 0 0px',
// // //                   minWidth: painelAberto ? 260 : 0,
// // //                   maxWidth: 640,
// // //                   borderRight: painelAberto ? '1px solid #e7e7e7' : 'none',
// // //                   /**
// // //                    * Fica oculto por display, não desmontado: assim a
// // //                    * pesquisa digitada, o filtro e a rolagem da tabela
// // //                    * continuam como estavam ao reabrir o painel.
// // //                    */
// // //                   display: painelAberto ? 'flex' : 'none',
// // //                   flexDirection: 'column',
// // //                   minHeight: 0, // necessário para overflow funcionar em flex
// // //                 }}
// // //               >
// // //                 {/* Cabeçalho fixo no painel */}
// // //                 <div
// // //                   style={{
// // //                     position: 'sticky',
// // //                     top: 0,
// // //                     zIndex: 1,
// // //                     background: '#fff',
// // //                     borderBottom: '1px solid #eee',
// // //                     padding: '12px 12px 10px',
// // //                     display: 'grid',
// // //                     gridTemplateColumns: '1fr',
// // //                     gap: 8,
// // //                   }}
// // //                 >
// // //                   <Pagination
// // //                     pageCount={totalPage}
// // //                     initialData={currentPage}
// // //                     onPageChange={(selected) => {
// // //                       setCurrentPage(selected);
// // //                     }}
// // //                     location={{
// // //                       catalogo: catalogo.idCatalogo,
// // //                       pagina: paginaCatalogo ? paginaCatalogo.idPagina : 0,
// // //                     }}
// // //                   />
// // //                   {paginaCatalogo && (
// // //                     <>
// // //                       <Form
// // //                         ref={formRef}
// // //                         id="editorForm"
// // //                         onSubmit={handleConfirmar}
// // //                       >
// // //                         <Input id="caminho" name="caminho" isHidden />
// // //                       </Form>

// // //                       <Form ref={formPesqRef} autoComplete="off">
// // //                         <Input
// // //                           id="pesquisa"
// // //                           name="pesquisa"
// // //                           placeholder="Digite o item para pesquisar..."
// // //                           onChange={handlePesquisar}
// // //                           autoFocus
// // //                         />
// // //                       </Form>

// // //                       <div
// // //                         style={{
// // //                           display: 'flex',
// // //                           alignItems: 'center',
// // //                           justifyContent: 'space-between',
// // //                           gap: 8,
// // //                         }}
// // //                       >
// // //                         <Switch
// // //                           rigthText="Ocultar relacionados"
// // //                           defaultChecked={linkedFiltro}
// // //                           onChange={handleFiltrar}
// // //                         />
// // //                         {/* micro-resumo por conveniência */}
// // //                         <div
// // //                           style={{
// // //                             fontSize: 10,
// // //                             color: '#666',
// // //                             display: 'flex',
// // //                             gap: 10,
// // //                           }}
// // //                         >
// // //                           <span
// // //                             style={{
// // //                               fontSize: 10,
// // //                               background: '#eef7ff',
// // //                               border: '1px solid #d6ebff',
// // //                               padding: '4px 8px',
// // //                               borderRadius: 6,
// // //                             }}
// // //                             title="Total de itens na página"
// // //                           >
// // //                             <b>{total}</b>
// // //                           </span>
// // //                           <span
// // //                             style={{
// // //                               fontSize: 10,
// // //                               background: '#e8f8ef',
// // //                               border: '1px solid #cdeedb',
// // //                               padding: '4px 8px',
// // //                               borderRadius: 6,
// // //                             }}
// // //                             title="Itens vinculados a links"
// // //                           >
// // //                             <b>{vinculados}</b>
// // //                           </span>
// // //                           <span
// // //                             style={{
// // //                               fontSize: 10,
// // //                               background: '#fff4e5',
// // //                               border: '1px solid #ffe5bf',
// // //                               padding: '4px 8px',
// // //                               borderRadius: 6,
// // //                             }}
// // //                             title="Itens ainda pendentes"
// // //                           >
// // //                             <b>{pendentes}</b>
// // //                           </span>
// // //                         </div>
// // //                       </div>
// // //                     </>
// // //                   )}
// // //                 </div>

// // //                 {/* Área rolável da tabela */}
// // //                 <div
// // //                   style={{
// // //                     flex: '1 1 auto',
// // //                     overflow: 'auto',
// // //                     padding: '8px 8px 12px',
// // //                     minHeight: 0,
// // //                     background: '#fff',
// // //                   }}
// // //                 >
// // //                   {paginaCatalogo && itensPagina && (
// // //                     <EditorTable
// // //                       ref={tableRef}
// // //                       idCatalogo={id}
// // //                       idPagina={paginaCatalogo.idPagina}
// // //                       itensPagina={itensFiltro}
// // //                       isDraggable
// // //                       onLinkHighlight={(links, component) => {
// // //                         handleHighlight(links, component);
// // //                       }}
// // //                       /** leva o desenho até o link do item clicado */
// // //                       onGoToLink={(idItem) => {
// // //                         if (editorRef.current && editorRef.current.irParaLink) {
// // //                           editorRef.current.irParaLink(idItem);
// // //                         }
// // //                       }}
// // //                       /**
// // //                        * Item sem link: define como alvo do modo sequência,
// // //                        * para o próximo arraste no desenho criar a área dele.
// // //                        */
// // //                       onSelectPending={(item) => {
// // //                         if (
// // //                           editorRef.current &&
// // //                           editorRef.current.setItemSequencia
// // //                         ) {
// // //                           editorRef.current.setItemSequencia(item);
// // //                         }
// // //                       }}
// // //                     />
// // //                   )}
// // //                 </div>
// // //               </div>

// // //               {/* Barra de redimensionamento (só faz sentido com o painel aberto) */}
// // //               {painelAberto && (
// // //                 <div
// // //                   role="separator"
// // //                   aria-orientation="vertical"
// // //                   title="Arraste para redimensionar"
// // //                   onMouseDown={onStartResize}
// // //                   style={{
// // //                     width: 6,
// // //                     cursor: 'col-resize',
// // //                     background: isResizing
// // //                       ? 'rgba(0,0,0,0.15)'
// // //                       : 'rgba(0,0,0,0.06)',
// // //                     transition: 'background 120ms ease',
// // //                   }}
// // //                 />
// // //               )}

// // //               {/* Canvas (EditorArea) */}
// // //               <div
// // //                 style={{
// // //                   flex: '1 1 auto',
// // //                   minWidth: 0,
// // //                   /** o editor precisa da altura para esticar o desenho */
// // //                   display: 'flex',
// // //                   minHeight: 0,
// // //                 }}
// // //               >
// // //                 <EditorArea
// // //                   ref={editorRef}
// // //                   pagina={paginaCatalogo}
// // //                   itensPagina={itensPagina}
// // //                   catalogo={catalogo}
// // //                   onSave={handleSalvar}
// // //                   onCancel={handleCancelar}
// // //                   onBeforeOCR={() => setLoading(true)}
// // //                   onAfterOCR={() => setLoading(false)}
// // //                   onAssociate={(links) => {
// // //                     handleLink(links);
// // //                   }}
// // //                   onLinkHighlight={(links, component) => {
// // //                     handleHighlight(links, component);
// // //                   }}
// // //                 />
// // //               </div>
// // //             </div>
// // //           </EditorContainer.EditorArea>
// // //         )}
// // //       </EditorContainer.Wrapper>
// // //     </EditorContainer>
// // //   );
// // // }

// // // export default EditorAssociarAI;

// // /* eslint-disable consistent-return */
// // import React, { useEffect, useState, useCallback, useRef } from 'react';
// // import { useLocation } from 'react-router-dom';
// // import { useSelector } from 'react-redux';
// // import { toast } from 'react-toastify';
// // import {
// //   MdTableRows,
// //   MdImage,
// //   MdSchema,
// //   MdChevronLeft,
// //   MdChevronRight,
// //   MdFullscreen,
// //   MdFullscreenExit,
// // } from 'react-icons/md';

// // import api from '../../services/api';
// // import history from '../../services/history';

// // import { AppError } from '../../errors/AppError';
// // import { opPaginaCatalogoSituacao, opTipoAcesso } from '../../lib/const';

// // import TitleBar from '../../components/TitleBar';
// // import EditorArea from '../../components/EditorAI/index';
// // import EditorTable from '../../components/EditorAI/Table';
// // import Pagination from '../../components/EditorAI/Pagination';
// // import Switch from '../../components/Form/Input/Switch';

// // import { Form } from '../../components/Form';
// // import Input from '../../components/Form/Input';
// // import Loading from '../../components/Loading';

// // import { EditorContainer } from '../../components/Container';

// // import { Action } from './styles';

// // function EditorAssociarAI() {
// //   const location = useLocation();
// //   const { id, paginaInicial = 0 } = location.state;

// //   const editorRef = useRef();
// //   const tableRef = useRef();
// //   const formRef = useRef();
// //   const formPesqRef = useRef();

// //   // refs/estado para layout
// //   const layoutRef = useRef(null);
// //   const [sidebarWidth, setSidebarWidth] = useState(380);
// //   const [isResizing, setIsResizing] = useState(false);

// //   /**
// //    * ===================================================================
// //    * ÁREA DE TRABALHO
// //    * -------------------------------------------------------------------
// //    * Dois controles para o desenho ganhar tela:
// //    *
// //    *  - painelAberto: recolhe o painel de itens para um trilho estreito,
// //    *    devolvendo a largura inteira ao desenho sem perder o acesso à
// //    *    tabela (um clique traz de volta, na mesma largura).
// //    *
// //    *  - modoAmplo: o editor passa a ocupar a janela toda, por cima do
// //    *    header e do rodapé da aplicação. Sai por Esc ou pelo botão.
// //    * ===================================================================
// //    */
// //   const [painelAberto, setPainelAberto] = useState(true);
// //   const [modoAmplo, setModoAmplo] = useState(false);

// //   /**
// //    * Exclusão de item de página é restrita a administrador: o backend
// //    * devolve 401 para os demais perfis (ItemPaginaLoteController). O mesmo
// //    * critério é aplicado aqui para a lixeira nem aparecer para quem não
// //    * pode usá-la.
// //    */
// //   const { adm } = useSelector((state) => state.user.profile || {});

// //   const podeExcluirItens = [
// //     opTipoAcesso.ADMIN_PLATAFORMA,
// //     opTipoAcesso.ADMIN_EMPRESA,
// //   ].includes(Number(adm));

// //   const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

// //   const [catalogo, setCatalogo] = useState(null);
// //   const [paginaCatalogo, setPaginaCatalogo] = useState(null);
// //   const [itensPagina, setItensPagina] = useState([]);
// //   const [itensFiltro, setItensFiltro] = useState([]);
// //   const [linkedFiltro, setLinkedFiltro] = useState(false);
// //   const [loading, setLoading] = useState(false);

// //   /** controle de pesquisa */
// //   const [search, setSearch] = useState();

// //   /** controle de páginas */
// //   const [currentPage, setCurrentPage] = useState(null);
// //   const [totalPage, setTotalPage] = useState(0);

// //   const carregaPagina = useCallback(async () => {
// //     /** limpa variável de itens */
// //     setItensPagina([]);
// //     setItensFiltro([]);

// //     /** limpa campo de pesquisa */
// //     if (formPesqRef.current) {
// //       formPesqRef.current.reset();
// //     }

// //     /** cancela operação se não houver catálogo e página para busca */
// //     if (!(catalogo && currentPage)) return true;

// //     const pagina = catalogo.paginas[currentPage - 1];

// //     /** cancela operação se página não existir */
// //     if (!pagina) return true;

// //     setLoading(true);
// //     try {
// //       /** carrega itens da página */
// //       const response = await api.get(`editor-associar/${id}/pagina/${pagina}`);
// //       setPaginaCatalogo(response.data);

// //       setItensPagina(() =>
// //         response.data.itemPagina.map((item) => ({
// //           ...item,
// //           ...item.materialFabricante,
// //           linked: false,
// //           highlighted: false,
// //           locked: false,
// //         }))
// //       );

// //       setSearch('');
// //     } finally {
// //       setLoading(false);
// //       if (editorRef.current) editorRef.current.getLinked();
// //     }
// //   }, [id, catalogo, currentPage]);

// //   useEffect(() => {
// //     /** informações do catálogo */
// //     api.get(`editor-associar/${id}`).then((response) => {
// //       const paginas = response.data.paginaCatalogo || [];

// //       setPaginaCatalogo(null);

// //       setCatalogo({
// //         ...response.data,
// //         paginas: paginas.map((pagina) => pagina.idPagina),
// //       });

// //       setTotalPage(response.data.total);

// //       setCurrentPage(() => {
// //         /** index da última página concluída do catálogo */
// //         const lastIndex = Math.max(
// //           ...paginas.reduce((acumuladoPagina, atualPagina, index) => {
// //             // adiciona primeira página
// //             if (
// //               index === 0 ||
// //               atualPagina.situacao === opPaginaCatalogoSituacao.CONCLUIDO
// //             ) {
// //               acumuladoPagina.push(index);
// //             }

// //             return acumuladoPagina;
// //           }, [])
// //         );

// //         const lastDonePage = lastIndex + 1;

// //         return paginaInicial || lastDonePage;
// //       });
// //     });
// //   }, [id, paginaInicial]);

// //   useEffect(() => {
// //     carregaPagina();
// //   }, [id, catalogo, currentPage, carregaPagina]);

// //   const handleSalvar = useCallback(async ({ svg }) => {
// //     const formData = new FormData();
// //     formData.append('file', svg);

// //     /** enviar o arquivo para o servidor e recebe o local em que ele foi armazenado */
// //     const response = await api.post('files', formData);
// //     const { path } = response.data;

// //     formRef.current.setFieldValue('caminho', path);

// //     formRef.current.submitForm();
// //   }, []);

// //   const handleCancelar = useCallback(async () => {
// //     carregaPagina();
// //   }, [carregaPagina]);

// //   const handleConfirmar = useCallback(
// //     async (data) => {
// //       setLoading(true);
// //       try {
// //         const { caminho } = data;
// //         const { idPagina } = paginaCatalogo;

// //         /** envia todas as informações para serem persistidas */
// //         await api.put(`editor-associar/${id}/pagina/${idPagina}`, {
// //           caminho,
// //         });

// //         carregaPagina();

// //         /** mensagem de sucesso */
// //         toast.success('Página salva com sucesso!');
// //       } catch (err) {
// //         AppError(err, formRef);
// //       } finally {
// //         setLoading(false);
// //       }
// //     },
// //     [id, paginaCatalogo, carregaPagina]
// //   );

// //   const handleFiltro = useCallback(
// //     (searching, filtered) => {
// //       setItensFiltro(() => {
// //         let newValue = itensPagina;

// //         if (filtered) newValue = newValue.filter((item) => !item.linked);

// //         if (searching)
// //           newValue = newValue.filter((item) =>
// //             String(item.idItem)
// //               .toUpperCase()
// //               .startsWith(String(searching).toUpperCase())
// //           );

// //         return newValue;
// //       });

// //       setSearch(searching);
// //       setLinkedFiltro(filtered);
// //     },
// //     [itensPagina]
// //   );

// //   const handlePesquisar = useCallback(
// //     (e) => {
// //       handleFiltro(e.target.value, linkedFiltro);
// //     },
// //     [linkedFiltro, handleFiltro]
// //   );

// //   const handleFiltrar = useCallback(() => {
// //     handleFiltro(search, !linkedFiltro);
// //   }, [search, linkedFiltro, handleFiltro]);

// //   const handleLink = useCallback((itens) => {
// //     const lockStates = tableRef.current ? tableRef.current.getLockStates() : [];

// //     setItensPagina((old) =>
// //       old.map((item) => {
// //         const { locked } =
// //           lockStates.find((link) => link.idItem === item.idItem) || false;

// //         const linked = itens.includes(item.idItem);

// //         return {
// //           ...item,
// //           linked,
// //           highlighted: false,
// //           locked: linked && locked,
// //         };
// //       })
// //     );
// //   }, []);

// //   const handleHighlight = useCallback((links, component) => {
// //     let ref = null;
// //     switch (component) {
// //       case 'table':
// //         ref = editorRef.current;
// //         break;
// //       case 'editor':
// //         ref = tableRef.current;
// //         break;
// //       default:
// //         break;
// //     }

// //     if (ref) ref.highlightLinks(links);
// //   }, []);

// //   useEffect(
// //     () => {
// //       handleFiltro(search, linkedFiltro);
// //     },
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //     [handleFiltro]
// //   );

// //   /** redireciona para a referencia */
// //   const handleNavegar = useCallback(
// //     (param = 'isClassificar' || 'isExtrair' || 'isEditar') => {
// //       const { idPagina } = paginaCatalogo || {};

// //       if (!idPagina) {
// //         throw new AppError('Referência não encontrada!');
// //       }

// //       try {
// //         switch (param) {
// //           case 'isClassificar':
// //             history.replace(`/edicao/classificarAI`, {
// //               id,
// //               paginaInicial: idPagina,
// //             });
// //             break;
// //           case 'isExtrair':
// //             api.get(`editor-extrair/${id}`).then((response) => {
// //               const paginaIndex = response.data.paginaCatalogo.findIndex(
// //                 (pagina) => pagina.referencia === idPagina
// //               );

// //               if (paginaIndex === -1)
// //                 throw new AppError(
// //                   'Não há tabela com referência para esta página'
// //                 );

// //               history.replace(`/edicao/extrairAI`, {
// //                 id,
// //                 paginaInicial: paginaIndex + 1,
// //               });
// //             });
// //             break;
// //           case 'isEditar':
// //             api.get(`editor-editar/${id}`).then((response) => {
// //               const paginaIndex = response.data.paginaCatalogo.findIndex(
// //                 (pagina) => pagina.idPagina === idPagina
// //               );
// //               history.replace(`/edicao/editarAI`, {
// //                 id,
// //                 paginaInicial: paginaIndex + 1,
// //               });
// //             });
// //             break;
// //           default:
// //             break;
// //         }
// //       } catch (err) {
// //         AppError(err);
// //       }
// //     },
// //     [id, paginaCatalogo]
// //   );

// //   const handleVoltar = useCallback(() => {
// //     history.replace('/edicao/editarAI', { id });
// //   }, [id]);

// //   /**
// //    * Exclusão em lote dos itens marcados na coluna lateral.
// //    *
// //    * Usa o mesmo endpoint já empregado na tela de itens da página
// //    * (PATCH catalogo/:id/item). Devolve true quando concluiu, para a
// //    * tabela poder encerrar o modo de seleção.
// //    */
// //   const handleExcluirItens = useCallback(
// //     async (itens) => {
// //       /**
// //        * GUARDA OBRIGATÓRIA: RemoverItemPaginaService apaga TODOS os itens
// //        * da página quando recebe a lista vazia. Nunca enviar sem itens.
// //        */
// //       if (!Array.isArray(itens) || itens.length === 0) {
// //         toast.info('Selecione ao menos um item para excluir.');
// //         return false;
// //       }

// //       if (!paginaCatalogo) return false;

// //       setLoading(true);
// //       try {
// //         await api.patch(`catalogo/${id}/item`, {
// //           idPagina: Number(paginaCatalogo.idPagina),
// //           itens,
// //         });

// //         toast.success(
// //           itens.length === 1
// //             ? 'Item excluído com sucesso!'
// //             : 'Itens excluídos com sucesso!'
// //         );

// //         await carregaPagina();

// //         return true;
// //       } catch (err) {
// //         AppError(err);
// //         return false;
// //       } finally {
// //         setLoading(false);
// //       }
// //     },
// //     [id, paginaCatalogo, carregaPagina]
// //   );

// //   /** ---- Layout: redimensionamento lateral ---- */
// //   const onStartResize = useCallback((e) => {
// //     e.preventDefault();
// //     setIsResizing(true);
// //   }, []);

// //   useEffect(() => {
// //     if (!isResizing) return;

// //     const onMove = (e) => {
// //       if (!layoutRef.current) return;
// //       const rect = layoutRef.current.getBoundingClientRect();
// //       const next = clamp(e.clientX - rect.left, 260, 640); // limites
// //       setSidebarWidth(next);
// //     };

// //     const onUp = () => setIsResizing(false);

// //     window.addEventListener('mousemove', onMove);
// //     window.addEventListener('mouseup', onUp);
// //     return () => {
// //       window.removeEventListener('mousemove', onMove);
// //       window.removeEventListener('mouseup', onUp);
// //     };
// //   }, [isResizing]);

// //   /**
// //    * Esc sai do modo amplo. Fica no window porque o foco costuma estar no
// //    * desenho (que trata o próprio Esc para limpar a seleção) — por isso a
// //    * checagem só sai do modo quando ele está ativo.
// //    */
// //   useEffect(() => {
// //     if (!modoAmplo) return undefined;

// //     const onEsc = (e) => {
// //       if (e.key === 'Escape' || e.keyCode === 27) setModoAmplo(false);
// //     };

// //     window.addEventListener('keydown', onEsc);
// //     return () => window.removeEventListener('keydown', onEsc);
// //   }, [modoAmplo]);

// //   /** ---- Derivados de status ---- */
// //   const total = itensPagina.length;
// //   const vinculados = itensPagina.filter((i) => i.linked).length;
// //   const pendentes = total - vinculados;

// //   return (
// //     /**
// //      * O teto de 1440px foi retirado: em monitor maior a largura sobrando
// //      * ia para as margens em vez de ir para o desenho. No modo amplo o
// //      * container sai do fluxo e cobre a janela inteira.
// //      */
// //     <EditorContainer
// //       style={
// //         modoAmplo
// //           ? {
// //               position: 'fixed',
// //               top: 0,
// //               left: 0,
// //               right: 0,
// //               bottom: 0,
// //               zIndex: 60,
// //               background: '#f2f5fc',
// //               padding: 8,
// //               margin: 0,
// //               maxWidth: 'none',
// //             }
// //           : undefined
// //       }
// //     >
// //       <TitleBar back onBack={() => handleVoltar()} title="Mapeamento">
// //         <Action.BtnSquare
// //           type="button"
// //           title={
// //             painelAberto
// //               ? 'Recolher o painel de itens (mais espaço para o desenho)'
// //               : 'Mostrar o painel de itens'
// //           }
// //           className="btn-nav-ref"
// //           aria-pressed={!painelAberto}
// //           onClick={() => setPainelAberto((atual) => !atual)}
// //         >
// //           {painelAberto ? (
// //             <MdChevronLeft size={30} />
// //           ) : (
// //             <MdChevronRight size={30} />
// //           )}
// //         </Action.BtnSquare>
// //         <Action.BtnSquare
// //           type="button"
// //           title={
// //             modoAmplo
// //               ? 'Sair do modo tela cheia (Esc)'
// //               : 'Modo tela cheia: usa a janela inteira para o desenho'
// //           }
// //           className="btn-nav-ref"
// //           aria-pressed={modoAmplo}
// //           onClick={() => setModoAmplo((atual) => !atual)}
// //         >
// //           {modoAmplo ? (
// //             <MdFullscreenExit size={30} />
// //           ) : (
// //             <MdFullscreen size={30} />
// //           )}
// //         </Action.BtnSquare>
// //         <Action.BtnSquare
// //           type="button"
// //           title="Navegar para o processo de Classificação"
// //           className="btn-nav-ref"
// //           onClick={() => handleNavegar('isClassificar')}
// //         >
// //           <MdSchema size={30} />
// //         </Action.BtnSquare>
// //         <Action.BtnSquare
// //           type="button"
// //           title="Navegar para o processo de Extração"
// //           className="btn-nav-ref"
// //           onClick={() => handleNavegar('isExtrair')}
// //         >
// //           <MdTableRows size={30} />
// //         </Action.BtnSquare>
// //         <Action.BtnSquare
// //           type="button"
// //           title="Navegar para o processo de Edição"
// //           className="btn-nav-ref"
// //           onClick={() => handleNavegar('isEditar')}
// //         >
// //           <MdImage size={30} />
// //         </Action.BtnSquare>
// //       </TitleBar>

// //       <Loading visible={loading} />

// //       <EditorContainer.Wrapper>
// //         {catalogo && (
// //           <EditorContainer.EditorArea style={{ padding: 0 }}>
// //             {/* Layout flex com barra de redimensionamento */}
// //             <div
// //               ref={layoutRef}
// //               style={{
// //                 display: 'flex',
// //                 /**
// //                  * Altura de viewport em vez de altura automática: antes a
// //                  * área do desenho valia o tamanho intrínseco do SVG e
// //                  * sobrava tela sem uso embaixo. As variáveis estão em
// //                  * styles/global.js e já acompanham a densidade do tablet.
// //                  */
// //                 height: modoAmplo
// //                   ? /** tela cheia: só descontam a barra de título e os recuos do cartão */
// //                     'calc(100vh - var(--edt-titlebar-h) - (var(--edt-card-pad-y) * 2) - 16px)'
// //                   : 'calc(100vh - var(--edt-chrome-h))',
// //                 minHeight: 380,
// //                 width: '100%',
// //                 position: 'relative',
// //               }}
// //             >
// //               {/**
// //                * Painel lateral (controles + tabela).
// //                * Recolhido, sai do layout por inteiro e o desenho recebe
// //                * a largura toda; a largura ajustada pelo arraste é
// //                * preservada para quando voltar.
// //                */}
// //               <div
// //                 style={{
// //                   flex: painelAberto
// //                     ? `0 0 ${Math.round(sidebarWidth)}px`
// //                     : '0 0 0px',
// //                   minWidth: painelAberto ? 260 : 0,
// //                   maxWidth: 640,
// //                   borderRight: painelAberto ? '1px solid #e7e7e7' : 'none',
// //                   /**
// //                    * Fica oculto por display, não desmontado: assim a
// //                    * pesquisa digitada, o filtro e a rolagem da tabela
// //                    * continuam como estavam ao reabrir o painel.
// //                    */
// //                   display: painelAberto ? 'flex' : 'none',
// //                   flexDirection: 'column',
// //                   minHeight: 0, // necessário para overflow funcionar em flex
// //                 }}
// //               >
// //                 {/* Cabeçalho fixo no painel */}
// //                 <div
// //                   style={{
// //                     position: 'sticky',
// //                     top: 0,
// //                     zIndex: 1,
// //                     background: '#fff',
// //                     borderBottom: '1px solid #eee',
// //                     padding: '12px 12px 10px',
// //                     display: 'grid',
// //                     gridTemplateColumns: '1fr',
// //                     gap: 8,
// //                   }}
// //                 >
// //                   <Pagination
// //                     pageCount={totalPage}
// //                     initialData={currentPage}
// //                     onPageChange={(selected) => {
// //                       setCurrentPage(selected);
// //                     }}
// //                     location={{
// //                       catalogo: catalogo.idCatalogo,
// //                       pagina: paginaCatalogo ? paginaCatalogo.idPagina : 0,
// //                     }}
// //                   />
// //                   {paginaCatalogo && (
// //                     <>
// //                       <Form
// //                         ref={formRef}
// //                         id="editorForm"
// //                         onSubmit={handleConfirmar}
// //                       >
// //                         <Input id="caminho" name="caminho" isHidden />
// //                       </Form>

// //                       <Form ref={formPesqRef} autoComplete="off">
// //                         <Input
// //                           id="pesquisa"
// //                           name="pesquisa"
// //                           placeholder="Digite o item para pesquisar..."
// //                           onChange={handlePesquisar}
// //                           autoFocus
// //                         />
// //                       </Form>

// //                       <div
// //                         style={{
// //                           display: 'flex',
// //                           alignItems: 'center',
// //                           justifyContent: 'space-between',
// //                           gap: 8,
// //                         }}
// //                       >
// //                         <Switch
// //                           rigthText="Ocultar relacionados"
// //                           defaultChecked={linkedFiltro}
// //                           onChange={handleFiltrar}
// //                         />
// //                         {/* micro-resumo por conveniência */}
// //                         <div
// //                           style={{
// //                             fontSize: 10,
// //                             color: '#666',
// //                             display: 'flex',
// //                             gap: 10,
// //                           }}
// //                         >
// //                           <span
// //                             style={{
// //                               fontSize: 10,
// //                               background: '#eef7ff',
// //                               border: '1px solid #d6ebff',
// //                               padding: '4px 8px',
// //                               borderRadius: 6,
// //                             }}
// //                             title="Total de itens na página"
// //                           >
// //                             <b>{total}</b>
// //                           </span>
// //                           <span
// //                             style={{
// //                               fontSize: 10,
// //                               background: '#e8f8ef',
// //                               border: '1px solid #cdeedb',
// //                               padding: '4px 8px',
// //                               borderRadius: 6,
// //                             }}
// //                             title="Itens vinculados a links"
// //                           >
// //                             <b>{vinculados}</b>
// //                           </span>
// //                           <span
// //                             style={{
// //                               fontSize: 10,
// //                               background: '#fff4e5',
// //                               border: '1px solid #ffe5bf',
// //                               padding: '4px 8px',
// //                               borderRadius: 6,
// //                             }}
// //                             title="Itens ainda pendentes"
// //                           >
// //                             <b>{pendentes}</b>
// //                           </span>
// //                         </div>
// //                       </div>
// //                     </>
// //                   )}
// //                 </div>

// //                 {/* Área rolável da tabela */}
// //                 <div
// //                   style={{
// //                     flex: '1 1 auto',
// //                     overflow: 'auto',
// //                     padding: '8px 8px 12px',
// //                     minHeight: 0,
// //                     background: '#fff',
// //                   }}
// //                 >
// //                   {paginaCatalogo && itensPagina && (
// //                     <EditorTable
// //                       ref={tableRef}
// //                       idCatalogo={id}
// //                       idPagina={paginaCatalogo.idPagina}
// //                       itensPagina={itensFiltro}
// //                       isDraggable
// //                       onLinkHighlight={(links, component) => {
// //                         handleHighlight(links, component);
// //                       }}
// //                       /** leva o desenho até o link do item clicado */
// //                       onGoToLink={(idItem) => {
// //                         if (editorRef.current && editorRef.current.irParaLink) {
// //                           editorRef.current.irParaLink(idItem);
// //                         }
// //                       }}
// //                       /**
// //                        * Item sem link: define como alvo do modo sequência,
// //                        * para o próximo arraste no desenho criar a área dele.
// //                        */
// //                       onSelectPending={(item) => {
// //                         if (
// //                           editorRef.current &&
// //                           editorRef.current.setItemSequencia
// //                         ) {
// //                           editorRef.current.setItemSequencia(item);
// //                         }
// //                       }}
// //                       /** sem permissão, a lixeira não é renderizada */
// //                       onExcluirItens={
// //                         podeExcluirItens ? handleExcluirItens : null
// //                       }
// //                     />
// //                   )}
// //                 </div>
// //               </div>

// //               {/* Barra de redimensionamento (só faz sentido com o painel aberto) */}
// //               {painelAberto && (
// //                 <div
// //                   role="separator"
// //                   aria-orientation="vertical"
// //                   title="Arraste para redimensionar"
// //                   onMouseDown={onStartResize}
// //                   style={{
// //                     width: 6,
// //                     cursor: 'col-resize',
// //                     background: isResizing
// //                       ? 'rgba(0,0,0,0.15)'
// //                       : 'rgba(0,0,0,0.06)',
// //                     transition: 'background 120ms ease',
// //                   }}
// //                 />
// //               )}

// //               {/* Canvas (EditorArea) */}
// //               <div
// //                 style={{
// //                   flex: '1 1 auto',
// //                   minWidth: 0,
// //                   /** o editor precisa da altura para esticar o desenho */
// //                   display: 'flex',
// //                   minHeight: 0,
// //                 }}
// //               >
// //                 <EditorArea
// //                   ref={editorRef}
// //                   pagina={paginaCatalogo}
// //                   itensPagina={itensPagina}
// //                   catalogo={catalogo}
// //                   onSave={handleSalvar}
// //                   onCancel={handleCancelar}
// //                   onBeforeOCR={() => setLoading(true)}
// //                   onAfterOCR={() => setLoading(false)}
// //                   onAssociate={(links) => {
// //                     handleLink(links);
// //                   }}
// //                   onLinkHighlight={(links, component) => {
// //                     handleHighlight(links, component);
// //                   }}
// //                 />
// //               </div>
// //             </div>
// //           </EditorContainer.EditorArea>
// //         )}
// //       </EditorContainer.Wrapper>
// //     </EditorContainer>
// //   );
// // }

// // export default EditorAssociarAI;

// /* eslint-disable consistent-return */
// import React, { useEffect, useState, useCallback, useRef } from 'react';
// import { useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import {
//   MdTableRows,
//   MdImage,
//   MdSchema,
//   MdChevronLeft,
//   MdChevronRight,
//   MdFullscreen,
//   MdFullscreenExit,
// } from 'react-icons/md';

// import api from '../../services/api';
// import history from '../../services/history';

// import { AppError } from '../../errors/AppError';
// import { opPaginaCatalogoSituacao, opTipoAcesso } from '../../lib/const';

// import TitleBar from '../../components/TitleBar';
// import EditorArea from '../../components/EditorAI/index';
// import EditorTable from '../../components/EditorAI/Table';
// import Pagination from '../../components/EditorAI/Pagination';
// import Switch from '../../components/Form/Input/Switch';

// import { Form } from '../../components/Form';
// import Input from '../../components/Form/Input';
// import Loading from '../../components/Loading';

// import { EditorContainer } from '../../components/Container';

// import { Action } from './styles';

// function EditorAssociarAI() {
//   const location = useLocation();
//   const { id, paginaInicial = 0 } = location.state;

//   const editorRef = useRef();
//   const tableRef = useRef();
//   const formRef = useRef();
//   const formPesqRef = useRef();

//   // refs/estado para layout
//   const layoutRef = useRef(null);
//   const [sidebarWidth, setSidebarWidth] = useState(380);
//   const [isResizing, setIsResizing] = useState(false);

//   /**
//    * ===================================================================
//    * ÁREA DE TRABALHO
//    * -------------------------------------------------------------------
//    * Dois controles para o desenho ganhar tela:
//    *
//    *  - painelAberto: recolhe o painel de itens para um trilho estreito,
//    *    devolvendo a largura inteira ao desenho sem perder o acesso à
//    *    tabela (um clique traz de volta, na mesma largura).
//    *
//    *  - modoAmplo: o editor passa a ocupar a janela toda, por cima do
//    *    header e do rodapé da aplicação. Sai por Esc ou pelo botão.
//    * ===================================================================
//    */
//   const [painelAberto, setPainelAberto] = useState(true);
//   const [modoAmplo, setModoAmplo] = useState(false);

//   /**
//    * Exclusão de item de página é restrita a administrador: o backend
//    * devolve 401 para os demais perfis (ItemPaginaLoteController). O mesmo
//    * critério é aplicado aqui para a lixeira nem aparecer para quem não
//    * pode usá-la.
//    */
//   const { adm } = useSelector((state) => state.user.profile || {});

//   const podeExcluirItens = [
//     opTipoAcesso.ADMIN_PLATAFORMA,
//     opTipoAcesso.ADMIN_EMPRESA,
//   ].includes(Number(adm));

//   const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

//   const [catalogo, setCatalogo] = useState(null);
//   const [paginaCatalogo, setPaginaCatalogo] = useState(null);
//   const [itensPagina, setItensPagina] = useState([]);
//   const [itensFiltro, setItensFiltro] = useState([]);
//   const [linkedFiltro, setLinkedFiltro] = useState(false);
//   const [loading, setLoading] = useState(false);

//   /** controle de pesquisa */
//   const [search, setSearch] = useState();

//   /** controle de páginas */
//   const [currentPage, setCurrentPage] = useState(null);
//   const [totalPage, setTotalPage] = useState(0);

//   const carregaPagina = useCallback(async () => {
//     /** limpa variável de itens */
//     setItensPagina([]);
//     setItensFiltro([]);

//     /** limpa campo de pesquisa */
//     if (formPesqRef.current) {
//       formPesqRef.current.reset();
//     }

//     /** cancela operação se não houver catálogo e página para busca */
//     if (!(catalogo && currentPage)) return true;

//     const pagina = catalogo.paginas[currentPage - 1];

//     /** cancela operação se página não existir */
//     if (!pagina) return true;

//     setLoading(true);
//     try {
//       /** carrega itens da página */
//       const response = await api.get(`editor-associar/${id}/pagina/${pagina}`);
//       setPaginaCatalogo(response.data);

//       setItensPagina(() =>
//         response.data.itemPagina.map((item) => ({
//           ...item,
//           ...item.materialFabricante,
//           linked: false,
//           highlighted: false,
//           locked: false,
//         }))
//       );

//       setSearch('');
//     } finally {
//       setLoading(false);
//       if (editorRef.current) editorRef.current.getLinked();
//     }
//   }, [id, catalogo, currentPage]);

//   useEffect(() => {
//     /** informações do catálogo */
//     api.get(`editor-associar/${id}`).then((response) => {
//       const paginas = response.data.paginaCatalogo || [];

//       setPaginaCatalogo(null);

//       setCatalogo({
//         ...response.data,
//         paginas: paginas.map((pagina) => pagina.idPagina),
//       });

//       setTotalPage(response.data.total);

//       setCurrentPage(() => {
//         /** index da última página concluída do catálogo */
//         const lastIndex = Math.max(
//           ...paginas.reduce((acumuladoPagina, atualPagina, index) => {
//             // adiciona primeira página
//             if (
//               index === 0 ||
//               atualPagina.situacao === opPaginaCatalogoSituacao.CONCLUIDO
//             ) {
//               acumuladoPagina.push(index);
//             }

//             return acumuladoPagina;
//           }, [])
//         );

//         const lastDonePage = lastIndex + 1;

//         return paginaInicial || lastDonePage;
//       });
//     });
//   }, [id, paginaInicial]);

//   useEffect(() => {
//     carregaPagina();
//   }, [id, catalogo, currentPage, carregaPagina]);

//   const handleSalvar = useCallback(async ({ svg }) => {
//     const formData = new FormData();
//     formData.append('file', svg);

//     /** enviar o arquivo para o servidor e recebe o local em que ele foi armazenado */
//     const response = await api.post('files', formData);
//     const { path } = response.data;

//     formRef.current.setFieldValue('caminho', path);

//     formRef.current.submitForm();
//   }, []);

//   const handleCancelar = useCallback(async () => {
//     carregaPagina();
//   }, [carregaPagina]);

//   const handleConfirmar = useCallback(
//     async (data) => {
//       setLoading(true);
//       try {
//         const { caminho } = data;
//         const { idPagina } = paginaCatalogo;

//         /** envia todas as informações para serem persistidas */
//         await api.put(`editor-associar/${id}/pagina/${idPagina}`, {
//           caminho,
//         });

//         carregaPagina();

//         /** mensagem de sucesso */
//         toast.success('Página salva com sucesso!');
//       } catch (err) {
//         AppError(err, formRef);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [id, paginaCatalogo, carregaPagina]
//   );

//   const handleFiltro = useCallback(
//     (searching, filtered) => {
//       setItensFiltro(() => {
//         let newValue = itensPagina;

//         if (filtered) newValue = newValue.filter((item) => !item.linked);

//         if (searching)
//           newValue = newValue.filter((item) =>
//             String(item.idItem)
//               .toUpperCase()
//               .startsWith(String(searching).toUpperCase())
//           );

//         return newValue;
//       });

//       setSearch(searching);
//       setLinkedFiltro(filtered);
//     },
//     [itensPagina]
//   );

//   const handlePesquisar = useCallback(
//     (e) => {
//       handleFiltro(e.target.value, linkedFiltro);
//     },
//     [linkedFiltro, handleFiltro]
//   );

//   const handleFiltrar = useCallback(() => {
//     handleFiltro(search, !linkedFiltro);
//   }, [search, linkedFiltro, handleFiltro]);

//   const handleLink = useCallback((itens) => {
//     const lockStates = tableRef.current ? tableRef.current.getLockStates() : [];

//     setItensPagina((old) =>
//       old.map((item) => {
//         const { locked } =
//           lockStates.find((link) => link.idItem === item.idItem) || false;

//         const linked = itens.includes(item.idItem);

//         return {
//           ...item,
//           linked,
//           highlighted: false,
//           locked: linked && locked,
//         };
//       })
//     );
//   }, []);

//   const handleHighlight = useCallback((links, component) => {
//     let ref = null;
//     switch (component) {
//       case 'table':
//         ref = editorRef.current;
//         break;
//       case 'editor':
//         ref = tableRef.current;
//         break;
//       default:
//         break;
//     }

//     if (ref) ref.highlightLinks(links);
//   }, []);

//   useEffect(
//     () => {
//       handleFiltro(search, linkedFiltro);
//     },
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     [handleFiltro]
//   );

//   /** redireciona para a referencia */
//   const handleNavegar = useCallback(
//     (param = 'isClassificar' || 'isExtrair' || 'isEditar') => {
//       const { idPagina } = paginaCatalogo || {};

//       if (!idPagina) {
//         throw new AppError('Referência não encontrada!');
//       }

//       try {
//         switch (param) {
//           case 'isClassificar':
//             history.replace(`/edicao/classificarAI`, {
//               id,
//               paginaInicial: idPagina,
//             });
//             break;
//           case 'isExtrair':
//             api.get(`editor-extrair/${id}`).then((response) => {
//               const paginaIndex = response.data.paginaCatalogo.findIndex(
//                 (pagina) => pagina.referencia === idPagina
//               );

//               if (paginaIndex === -1)
//                 throw new AppError(
//                   'Não há tabela com referência para esta página'
//                 );

//               history.replace(`/edicao/extrairAI`, {
//                 id,
//                 paginaInicial: paginaIndex + 1,
//               });
//             });
//             break;
//           case 'isEditar':
//             api.get(`editor-editar/${id}`).then((response) => {
//               const paginaIndex = response.data.paginaCatalogo.findIndex(
//                 (pagina) => pagina.idPagina === idPagina
//               );
//               history.replace(`/edicao/editarAI`, {
//                 id,
//                 paginaInicial: paginaIndex + 1,
//               });
//             });
//             break;
//           default:
//             break;
//         }
//       } catch (err) {
//         AppError(err);
//       }
//     },
//     [id, paginaCatalogo]
//   );

//   const handleVoltar = useCallback(() => {
//     history.replace('/edicao/editarAI', { id });
//   }, [id]);

//   /**
//    * Exclusão em lote dos itens marcados na coluna lateral.
//    *
//    * Usa o mesmo endpoint já empregado na tela de itens da página
//    * (PATCH catalogo/:id/item). Devolve true quando concluiu, para a
//    * tabela poder encerrar o modo de seleção.
//    */
//   const handleExcluirItens = useCallback(
//     async (itens) => {
//       /**
//        * GUARDA OBRIGATÓRIA: RemoverItemPaginaService apaga TODOS os itens
//        * da página quando recebe a lista vazia. Nunca enviar sem itens.
//        */
//       if (!Array.isArray(itens) || itens.length === 0) {
//         toast.info('Selecione ao menos um item para excluir.');
//         return false;
//       }

//       if (!paginaCatalogo) return false;

//       setLoading(true);
//       try {
//         await api.patch(`catalogo/${id}/item`, {
//           idPagina: Number(paginaCatalogo.idPagina),
//           itens,
//         });

//         toast.success(
//           itens.length === 1
//             ? 'Item excluído com sucesso!'
//             : 'Itens excluídos com sucesso!'
//         );

//         await carregaPagina();

//         return true;
//       } catch (err) {
//         AppError(err);
//         return false;
//       } finally {
//         setLoading(false);
//       }
//     },
//     [id, paginaCatalogo, carregaPagina]
//   );

//   /** ---- Layout: redimensionamento lateral ---- */
//   const onStartResize = useCallback((e) => {
//     e.preventDefault();
//     setIsResizing(true);
//   }, []);

//   useEffect(() => {
//     if (!isResizing) return;

//     const onMove = (e) => {
//       if (!layoutRef.current) return;
//       const rect = layoutRef.current.getBoundingClientRect();
//       const next = clamp(e.clientX - rect.left, 260, 640); // limites
//       setSidebarWidth(next);
//     };

//     const onUp = () => setIsResizing(false);

//     window.addEventListener('mousemove', onMove);
//     window.addEventListener('mouseup', onUp);
//     return () => {
//       window.removeEventListener('mousemove', onMove);
//       window.removeEventListener('mouseup', onUp);
//     };
//   }, [isResizing]);

//   /**
//    * Esc sai do modo amplo. Fica no window porque o foco costuma estar no
//    * desenho (que trata o próprio Esc para limpar a seleção) — por isso a
//    * checagem só sai do modo quando ele está ativo.
//    */
//   useEffect(() => {
//     if (!modoAmplo) return undefined;

//     const onEsc = (e) => {
//       if (e.key === 'Escape' || e.keyCode === 27) setModoAmplo(false);
//     };

//     window.addEventListener('keydown', onEsc);
//     return () => window.removeEventListener('keydown', onEsc);
//   }, [modoAmplo]);

//   /** ---- Derivados de status ---- */
//   const total = itensPagina.length;
//   const vinculados = itensPagina.filter((i) => i.linked).length;
//   const pendentes = total - vinculados;

//   return (
//     /**
//      * O teto de 1440px foi retirado: em monitor maior a largura sobrando
//      * ia para as margens em vez de ir para o desenho. No modo amplo o
//      * container sai do fluxo e cobre a janela inteira.
//      */
//     <EditorContainer
//       style={
//         modoAmplo
//           ? {
//               position: 'fixed',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               zIndex: 60,
//               background: '#f2f5fc',
//               padding: 8,
//               margin: 0,
//               maxWidth: 'none',
//             }
//           : undefined
//       }
//     >
//       <TitleBar compacto back onBack={() => handleVoltar()} title="Mapeamento">
//         <Action.BtnSquare
//           type="button"
//           title={
//             painelAberto
//               ? 'Recolher o painel de itens (mais espaço para o desenho)'
//               : 'Mostrar o painel de itens'
//           }
//           className="btn-nav-ref"
//           aria-pressed={!painelAberto}
//           onClick={() => setPainelAberto((atual) => !atual)}
//         >
//           {painelAberto ? (
//             <MdChevronLeft size={30} />
//           ) : (
//             <MdChevronRight size={30} />
//           )}
//         </Action.BtnSquare>
//         <Action.BtnSquare
//           type="button"
//           title={
//             modoAmplo
//               ? 'Sair do modo tela cheia (Esc)'
//               : 'Modo tela cheia: usa a janela inteira para o desenho'
//           }
//           className="btn-nav-ref"
//           aria-pressed={modoAmplo}
//           onClick={() => setModoAmplo((atual) => !atual)}
//         >
//           {modoAmplo ? (
//             <MdFullscreenExit size={30} />
//           ) : (
//             <MdFullscreen size={30} />
//           )}
//         </Action.BtnSquare>
//         <Action.BtnSquare
//           type="button"
//           title="Navegar para o processo de Classificação"
//           className="btn-nav-ref"
//           onClick={() => handleNavegar('isClassificar')}
//         >
//           <MdSchema size={22} />
//         </Action.BtnSquare>
//         <Action.BtnSquare
//           type="button"
//           title="Navegar para o processo de Extração"
//           className="btn-nav-ref"
//           onClick={() => handleNavegar('isExtrair')}
//         >
//           <MdTableRows size={22} />
//         </Action.BtnSquare>
//         <Action.BtnSquare
//           type="button"
//           title="Navegar para o processo de Edição"
//           className="btn-nav-ref"
//           onClick={() => handleNavegar('isEditar')}
//         >
//           <MdImage size={22} />
//         </Action.BtnSquare>
//       </TitleBar>

//       <Loading visible={loading} />

//       <EditorContainer.Wrapper>
//         {catalogo && (
//           <EditorContainer.EditorArea style={{ padding: 0 }}>
//             {/* Layout flex com barra de redimensionamento */}
//             <div
//               ref={layoutRef}
//               style={{
//                 display: 'flex',
//                 /**
//                  * Altura de viewport em vez de altura automática: antes a
//                  * área do desenho valia o tamanho intrínseco do SVG e
//                  * sobrava tela sem uso embaixo. As variáveis estão em
//                  * styles/global.js e já acompanham a densidade do tablet.
//                  */
//                 height: modoAmplo
//                   ? /** tela cheia: só descontam a barra de título e os recuos do cartão */
//                     'calc(100vh - var(--edt-titlebar-h) - (var(--edt-card-pad-y) * 2) - 16px)'
//                   : 'calc(100vh - var(--edt-chrome-h))',
//                 minHeight: 380,
//                 width: '100%',
//                 position: 'relative',
//               }}
//             >
//               {/**
//                * Painel lateral (controles + tabela).
//                * Recolhido, sai do layout por inteiro e o desenho recebe
//                * a largura toda; a largura ajustada pelo arraste é
//                * preservada para quando voltar.
//                */}
//               <div
//                 style={{
//                   flex: painelAberto
//                     ? `0 0 ${Math.round(sidebarWidth)}px`
//                     : '0 0 0px',
//                   minWidth: painelAberto ? 260 : 0,
//                   maxWidth: 640,
//                   borderRight: painelAberto ? '1px solid #e7e7e7' : 'none',
//                   /**
//                    * Fica oculto por display, não desmontado: assim a
//                    * pesquisa digitada, o filtro e a rolagem da tabela
//                    * continuam como estavam ao reabrir o painel.
//                    */
//                   display: painelAberto ? 'flex' : 'none',
//                   flexDirection: 'column',
//                   minHeight: 0, // necessário para overflow funcionar em flex
//                 }}
//               >
//                 {/* Cabeçalho fixo no painel */}
//                 <div
//                   style={{
//                     position: 'sticky',
//                     top: 0,
//                     zIndex: 1,
//                     background: '#fff',
//                     borderBottom: '1px solid #eee',
//                     padding: '12px 12px 10px',
//                     display: 'grid',
//                     gridTemplateColumns: '1fr',
//                     gap: 8,
//                   }}
//                 >
//                   <Pagination
//                     pageCount={totalPage}
//                     initialData={currentPage}
//                     onPageChange={(selected) => {
//                       setCurrentPage(selected);
//                     }}
//                     location={{
//                       catalogo: catalogo.idCatalogo,
//                       pagina: paginaCatalogo ? paginaCatalogo.idPagina : 0,
//                     }}
//                   />
//                   {paginaCatalogo && (
//                     <>
//                       <Form
//                         ref={formRef}
//                         id="editorForm"
//                         onSubmit={handleConfirmar}
//                       >
//                         <Input id="caminho" name="caminho" isHidden />
//                       </Form>

//                       <Form ref={formPesqRef} autoComplete="off">
//                         <Input
//                           id="pesquisa"
//                           name="pesquisa"
//                           placeholder="Digite o item para pesquisar..."
//                           onChange={handlePesquisar}
//                           autoFocus
//                         />
//                       </Form>

//                       <div
//                         style={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'space-between',
//                           gap: 8,
//                         }}
//                       >
//                         <Switch
//                           rigthText="Ocultar relacionados"
//                           defaultChecked={linkedFiltro}
//                           onChange={handleFiltrar}
//                         />
//                         {/* micro-resumo por conveniência */}
//                         <div
//                           style={{
//                             fontSize: 10,
//                             color: '#666',
//                             display: 'flex',
//                             gap: 10,
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 10,
//                               background: '#eef7ff',
//                               border: '1px solid #d6ebff',
//                               padding: '4px 8px',
//                               borderRadius: 6,
//                             }}
//                             title="Total de itens na página"
//                           >
//                             <b>{total}</b>
//                           </span>
//                           <span
//                             style={{
//                               fontSize: 10,
//                               background: '#e8f8ef',
//                               border: '1px solid #cdeedb',
//                               padding: '4px 8px',
//                               borderRadius: 6,
//                             }}
//                             title="Itens vinculados a links"
//                           >
//                             <b>{vinculados}</b>
//                           </span>
//                           <span
//                             style={{
//                               fontSize: 10,
//                               background: '#fff4e5',
//                               border: '1px solid #ffe5bf',
//                               padding: '4px 8px',
//                               borderRadius: 6,
//                             }}
//                             title="Itens ainda pendentes"
//                           >
//                             <b>{pendentes}</b>
//                           </span>
//                         </div>
//                       </div>
//                     </>
//                   )}
//                 </div>

//                 {/* Área rolável da tabela */}
//                 <div
//                   style={{
//                     flex: '1 1 auto',
//                     overflow: 'auto',
//                     padding: '8px 8px 12px',
//                     minHeight: 0,
//                     background: '#fff',
//                   }}
//                 >
//                   {paginaCatalogo && itensPagina && (
//                     <EditorTable
//                       ref={tableRef}
//                       idCatalogo={id}
//                       idPagina={paginaCatalogo.idPagina}
//                       itensPagina={itensFiltro}
//                       isDraggable
//                       onLinkHighlight={(links, component) => {
//                         handleHighlight(links, component);
//                       }}
//                       /** leva o desenho até o link do item clicado */
//                       onGoToLink={(idItem) => {
//                         if (editorRef.current && editorRef.current.irParaLink) {
//                           editorRef.current.irParaLink(idItem);
//                         }
//                       }}
//                       /**
//                        * Item sem link: define como alvo do modo sequência,
//                        * para o próximo arraste no desenho criar a área dele.
//                        */
//                       onSelectPending={(item) => {
//                         if (
//                           editorRef.current &&
//                           editorRef.current.setItemSequencia
//                         ) {
//                           editorRef.current.setItemSequencia(item);
//                         }
//                       }}
//                       /** sem permissão, a lixeira não é renderizada */
//                       onExcluirItens={
//                         podeExcluirItens ? handleExcluirItens : null
//                       }
//                     />
//                   )}
//                 </div>
//               </div>

//               {/* Barra de redimensionamento (só faz sentido com o painel aberto) */}
//               {painelAberto && (
//                 <div
//                   role="separator"
//                   aria-orientation="vertical"
//                   title="Arraste para redimensionar"
//                   onMouseDown={onStartResize}
//                   style={{
//                     width: 6,
//                     cursor: 'col-resize',
//                     background: isResizing
//                       ? 'rgba(0,0,0,0.15)'
//                       : 'rgba(0,0,0,0.06)',
//                     transition: 'background 120ms ease',
//                   }}
//                 />
//               )}

//               {/* Canvas (EditorArea) */}
//               <div
//                 style={{
//                   flex: '1 1 auto',
//                   minWidth: 0,
//                   /** o editor precisa da altura para esticar o desenho */
//                   display: 'flex',
//                   minHeight: 0,
//                 }}
//               >
//                 <EditorArea
//                   ref={editorRef}
//                   pagina={paginaCatalogo}
//                   itensPagina={itensPagina}
//                   catalogo={catalogo}
//                   onSave={handleSalvar}
//                   onCancel={handleCancelar}
//                   onBeforeOCR={() => setLoading(true)}
//                   onAfterOCR={() => setLoading(false)}
//                   onAssociate={(links) => {
//                     handleLink(links);
//                   }}
//                   onLinkHighlight={(links, component) => {
//                     handleHighlight(links, component);
//                   }}
//                 />
//               </div>
//             </div>
//           </EditorContainer.EditorArea>
//         )}
//       </EditorContainer.Wrapper>
//     </EditorContainer>
//   );
// }

// export default EditorAssociarAI;

/* eslint-disable consistent-return */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  MdTableRows,
  MdImage,
  MdSchema,
  MdChevronLeft,
  MdChevronRight,
  MdFullscreen,
  MdFullscreenExit,
} from 'react-icons/md';

import api from '../../services/api';
import history from '../../services/history';

import { AppError } from '../../errors/AppError';
import { opPaginaCatalogoSituacao, opTipoAcesso } from '../../lib/const';

import TitleBar from '../../components/TitleBar';
import EditorArea from '../../components/EditorAI/index';
import EditorTable from '../../components/EditorAI/Table';
import Pagination from '../../components/EditorAI/Pagination';
import Switch from '../../components/Form/Input/Switch';

import { Form } from '../../components/Form';
import Input from '../../components/Form/Input';
import Loading from '../../components/Loading';

import { EditorContainer } from '../../components/Container';

import { Action } from './styles';

function EditorAssociarAI() {
  const location = useLocation();
  const { id, paginaInicial = 0 } = location.state;

  const editorRef = useRef();
  const tableRef = useRef();
  const formRef = useRef();
  const formPesqRef = useRef();

  // refs/estado para layout
  const layoutRef = useRef(null);
  const [sidebarWidth, setSidebarWidth] = useState(380);
  const [isResizing, setIsResizing] = useState(false);

  /**
   * ===================================================================
   * ÁREA DE TRABALHO
   * -------------------------------------------------------------------
   * Dois controles para o desenho ganhar tela:
   *
   *  - painelAberto: recolhe o painel de itens para um trilho estreito,
   *    devolvendo a largura inteira ao desenho sem perder o acesso à
   *    tabela (um clique traz de volta, na mesma largura).
   *
   *  - modoAmplo: o editor passa a ocupar a janela toda, por cima do
   *    header e do rodapé da aplicação. Sai por Esc ou pelo botão.
   * ===================================================================
   */
  const [painelAberto, setPainelAberto] = useState(true);
  const [modoAmplo, setModoAmplo] = useState(false);

  /**
   * Exclusão de item de página é restrita a administrador: o backend
   * devolve 401 para os demais perfis (ItemPaginaLoteController). O mesmo
   * critério é aplicado aqui para a lixeira nem aparecer para quem não
   * pode usá-la.
   */
  const { adm } = useSelector((state) => state.user.profile || {});

  const podeExcluirItens = [
    opTipoAcesso.ADMIN_PLATAFORMA,
    opTipoAcesso.ADMIN_EMPRESA,
  ].includes(Number(adm));

  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

  const [catalogo, setCatalogo] = useState(null);
  const [paginaCatalogo, setPaginaCatalogo] = useState(null);
  const [itensPagina, setItensPagina] = useState([]);
  const [itensFiltro, setItensFiltro] = useState([]);
  const [linkedFiltro, setLinkedFiltro] = useState(false);
  const [loading, setLoading] = useState(false);

  /** controle de pesquisa */
  const [search, setSearch] = useState();

  /** controle de páginas */
  const [currentPage, setCurrentPage] = useState(null);
  const [totalPage, setTotalPage] = useState(0);

  const carregaPagina = useCallback(async () => {
    /** limpa variável de itens */
    setItensPagina([]);
    setItensFiltro([]);

    /** limpa campo de pesquisa */
    if (formPesqRef.current) {
      formPesqRef.current.reset();
    }

    /** cancela operação se não houver catálogo e página para busca */
    if (!(catalogo && currentPage)) return true;

    const pagina = catalogo.paginas[currentPage - 1];

    /** cancela operação se página não existir */
    if (!pagina) return true;

    setLoading(true);
    try {
      /** carrega itens da página */
      const response = await api.get(`editor-associar/${id}/pagina/${pagina}`);
      setPaginaCatalogo(response.data);

      setItensPagina(() =>
        response.data.itemPagina.map((item) => ({
          ...item,
          ...item.materialFabricante,
          linked: false,
          highlighted: false,
          locked: false,
        }))
      );

      setSearch('');
    } finally {
      setLoading(false);
      if (editorRef.current) editorRef.current.getLinked();
    }
  }, [id, catalogo, currentPage]);

  useEffect(() => {
    /** informações do catálogo */
    api.get(`editor-associar/${id}`).then((response) => {
      const paginas = response.data.paginaCatalogo || [];

      setPaginaCatalogo(null);

      setCatalogo({
        ...response.data,
        paginas: paginas.map((pagina) => pagina.idPagina),
      });

      setTotalPage(response.data.total);

      setCurrentPage(() => {
        /** index da última página concluída do catálogo */
        const lastIndex = Math.max(
          ...paginas.reduce((acumuladoPagina, atualPagina, index) => {
            // adiciona primeira página
            if (
              index === 0 ||
              atualPagina.situacao === opPaginaCatalogoSituacao.CONCLUIDO
            ) {
              acumuladoPagina.push(index);
            }

            return acumuladoPagina;
          }, [])
        );

        const lastDonePage = lastIndex + 1;

        return paginaInicial || lastDonePage;
      });
    });
  }, [id, paginaInicial]);

  useEffect(() => {
    carregaPagina();
  }, [id, catalogo, currentPage, carregaPagina]);

  const handleSalvar = useCallback(async ({ svg }) => {
    const formData = new FormData();
    formData.append('file', svg);

    /** enviar o arquivo para o servidor e recebe o local em que ele foi armazenado */
    const response = await api.post('files', formData);
    const { path } = response.data;

    formRef.current.setFieldValue('caminho', path);

    formRef.current.submitForm();
  }, []);

  const handleCancelar = useCallback(async () => {
    carregaPagina();
  }, [carregaPagina]);

  const handleConfirmar = useCallback(
    async (data) => {
      setLoading(true);
      try {
        const { caminho } = data;
        const { idPagina } = paginaCatalogo;

        /** envia todas as informações para serem persistidas */
        await api.put(`editor-associar/${id}/pagina/${idPagina}`, {
          caminho,
        });

        carregaPagina();

        /** mensagem de sucesso */
        toast.success('Página salva com sucesso!');
      } catch (err) {
        AppError(err, formRef);
      } finally {
        setLoading(false);
      }
    },
    [id, paginaCatalogo, carregaPagina]
  );

  const handleFiltro = useCallback(
    (searching, filtered) => {
      setItensFiltro(() => {
        let newValue = itensPagina;

        if (filtered) newValue = newValue.filter((item) => !item.linked);

        if (searching)
          newValue = newValue.filter((item) =>
            String(item.idItem)
              .toUpperCase()
              .startsWith(String(searching).toUpperCase())
          );

        return newValue;
      });

      setSearch(searching);
      setLinkedFiltro(filtered);
    },
    [itensPagina]
  );

  const handlePesquisar = useCallback(
    (e) => {
      handleFiltro(e.target.value, linkedFiltro);
    },
    [linkedFiltro, handleFiltro]
  );

  const handleFiltrar = useCallback(() => {
    handleFiltro(search, !linkedFiltro);
  }, [search, linkedFiltro, handleFiltro]);

  const handleLink = useCallback((itens) => {
    const lockStates = tableRef.current ? tableRef.current.getLockStates() : [];

    setItensPagina((old) =>
      old.map((item) => {
        const { locked } =
          lockStates.find((link) => link.idItem === item.idItem) || false;

        const linked = itens.includes(item.idItem);

        return {
          ...item,
          linked,
          highlighted: false,
          locked: linked && locked,
        };
      })
    );
  }, []);

  const handleHighlight = useCallback((links, component) => {
    let ref = null;
    switch (component) {
      case 'table':
        ref = editorRef.current;
        break;
      case 'editor':
        ref = tableRef.current;
        break;
      default:
        break;
    }

    if (ref) ref.highlightLinks(links);
  }, []);

  useEffect(
    () => {
      handleFiltro(search, linkedFiltro);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleFiltro]
  );

  /** redireciona para a referencia */
  const handleNavegar = useCallback(
    (param = 'isClassificar' || 'isExtrair' || 'isEditar') => {
      const { idPagina } = paginaCatalogo || {};

      if (!idPagina) {
        throw new AppError('Referência não encontrada!');
      }

      try {
        switch (param) {
          case 'isClassificar':
            history.replace(`/edicao/classificarAI`, {
              id,
              paginaInicial: idPagina,
            });
            break;
          case 'isExtrair':
            api.get(`editor-extrair/${id}`).then((response) => {
              const paginaIndex = response.data.paginaCatalogo.findIndex(
                (pagina) => pagina.referencia === idPagina
              );

              if (paginaIndex === -1)
                throw new AppError(
                  'Não há tabela com referência para esta página'
                );

              history.replace(`/edicao/extrairAI`, {
                id,
                paginaInicial: paginaIndex + 1,
              });
            });
            break;
          case 'isEditar':
            api.get(`editor-editar/${id}`).then((response) => {
              const paginaIndex = response.data.paginaCatalogo.findIndex(
                (pagina) => pagina.idPagina === idPagina
              );
              history.replace(`/edicao/editarAI`, {
                id,
                paginaInicial: paginaIndex + 1,
              });
            });
            break;
          default:
            break;
        }
      } catch (err) {
        AppError(err);
      }
    },
    [id, paginaCatalogo]
  );

  const handleVoltar = useCallback(() => {
    history.replace('/edicao/editarAI', { id });
  }, [id]);

  /**
   * Exclusão em lote dos itens marcados na coluna lateral.
   *
   * Usa o mesmo endpoint já empregado na tela de itens da página
   * (PATCH catalogo/:id/item). Devolve true quando concluiu, para a
   * tabela poder encerrar o modo de seleção.
   */
  const handleExcluirItens = useCallback(
    async (itens) => {
      /**
       * GUARDA OBRIGATÓRIA: RemoverItemPaginaService apaga TODOS os itens
       * da página quando recebe a lista vazia. Nunca enviar sem itens.
       */
      if (!Array.isArray(itens) || itens.length === 0) {
        toast.info('Selecione ao menos um item para excluir.');
        return false;
      }

      if (!paginaCatalogo) return false;

      setLoading(true);
      try {
        await api.patch(`catalogo/${id}/item`, {
          idPagina: Number(paginaCatalogo.idPagina),
          itens,
        });

        toast.success(
          itens.length === 1
            ? 'Item excluído com sucesso!'
            : 'Itens excluídos com sucesso!'
        );

        await carregaPagina();

        return true;
      } catch (err) {
        AppError(err);
        return false;
      } finally {
        setLoading(false);
      }
    },
    [id, paginaCatalogo, carregaPagina]
  );

  /** ---- Layout: redimensionamento lateral ---- */
  const onStartResize = useCallback((e) => {
    e.preventDefault();
    setIsResizing(true);
  }, []);

  useEffect(() => {
    if (!isResizing) return;

    const onMove = (e) => {
      if (!layoutRef.current) return;
      const rect = layoutRef.current.getBoundingClientRect();
      const next = clamp(e.clientX - rect.left, 260, 640); // limites
      setSidebarWidth(next);
    };

    const onUp = () => setIsResizing(false);

    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
  }, [isResizing]);

  /**
   * Esc sai do modo amplo. Fica no window porque o foco costuma estar no
   * desenho (que trata o próprio Esc para limpar a seleção) — por isso a
   * checagem só sai do modo quando ele está ativo.
   */
  useEffect(() => {
    if (!modoAmplo) return undefined;

    const onEsc = (e) => {
      if (e.key === 'Escape' || e.keyCode === 27) setModoAmplo(false);
    };

    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, [modoAmplo]);

  /** ---- Derivados de status ---- */
  const total = itensPagina.length;
  const vinculados = itensPagina.filter((i) => i.linked).length;
  const pendentes = total - vinculados;

  return (
    /**
     * O teto de 1440px foi retirado: em monitor maior a largura sobrando
     * ia para as margens em vez de ir para o desenho. No modo amplo o
     * container sai do fluxo e cobre a janela inteira.
     */
    <EditorContainer
      /**
       * Só esta tela usa o container elástico: é a única que define uma
       * altura de viewport no layout interno. Nas demais o cartão
       * continua se ajustando ao conteúdo (ver Container/index.js).
       */
      alturaTela
      style={
        modoAmplo
          ? {
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 60,
              background: '#f2f5fc',
              padding: 8,
              margin: 0,
              maxWidth: 'none',
            }
          : undefined
      }
    >
      <TitleBar compacto back onBack={() => handleVoltar()} title="Mapeamento">
        <Action.BtnSquare
          type="button"
          title={
            painelAberto
              ? 'Recolher o painel de itens (mais espaço para o desenho)'
              : 'Mostrar o painel de itens'
          }
          className="btn-nav-ref"
          aria-pressed={!painelAberto}
          onClick={() => setPainelAberto((atual) => !atual)}
        >
          {painelAberto ? (
            <MdChevronLeft size={30} />
          ) : (
            <MdChevronRight size={30} />
          )}
        </Action.BtnSquare>
        <Action.BtnSquare
          type="button"
          title={
            modoAmplo
              ? 'Sair do modo tela cheia (Esc)'
              : 'Modo tela cheia: usa a janela inteira para o desenho'
          }
          className="btn-nav-ref"
          aria-pressed={modoAmplo}
          onClick={() => setModoAmplo((atual) => !atual)}
        >
          {modoAmplo ? (
            <MdFullscreenExit size={30} />
          ) : (
            <MdFullscreen size={30} />
          )}
        </Action.BtnSquare>
        <Action.BtnSquare
          type="button"
          title="Navegar para o processo de Classificação"
          className="btn-nav-ref"
          onClick={() => handleNavegar('isClassificar')}
        >
          <MdSchema size={22} />
        </Action.BtnSquare>
        <Action.BtnSquare
          type="button"
          title="Navegar para o processo de Extração"
          className="btn-nav-ref"
          onClick={() => handleNavegar('isExtrair')}
        >
          <MdTableRows size={22} />
        </Action.BtnSquare>
        <Action.BtnSquare
          type="button"
          title="Navegar para o processo de Edição"
          className="btn-nav-ref"
          onClick={() => handleNavegar('isEditar')}
        >
          <MdImage size={22} />
        </Action.BtnSquare>
      </TitleBar>

      <Loading visible={loading} />

      <EditorContainer.Wrapper alturaTela>
        {catalogo && (
          <EditorContainer.EditorArea alturaTela style={{ padding: 0 }}>
            {/* Layout flex com barra de redimensionamento */}
            <div
              ref={layoutRef}
              style={{
                display: 'flex',
                /**
                 * Altura de viewport em vez de altura automática: antes a
                 * área do desenho valia o tamanho intrínseco do SVG e
                 * sobrava tela sem uso embaixo. As variáveis estão em
                 * styles/global.js e já acompanham a densidade do tablet.
                 */
                height: modoAmplo
                  ? /** tela cheia: só descontam a barra de título e os recuos do cartão */
                    'calc(100vh - var(--edt-titlebar-h) - (var(--edt-card-pad-y) * 2) - 16px)'
                  : 'calc(100vh - var(--edt-chrome-h))',
                minHeight: 380,
                width: '100%',
                position: 'relative',
              }}
            >
              {/**
               * Painel lateral (controles + tabela).
               * Recolhido, sai do layout por inteiro e o desenho recebe
               * a largura toda; a largura ajustada pelo arraste é
               * preservada para quando voltar.
               */}
              <div
                style={{
                  flex: painelAberto
                    ? `0 0 ${Math.round(sidebarWidth)}px`
                    : '0 0 0px',
                  minWidth: painelAberto ? 260 : 0,
                  maxWidth: 640,
                  borderRight: painelAberto ? '1px solid #e7e7e7' : 'none',
                  /**
                   * Fica oculto por display, não desmontado: assim a
                   * pesquisa digitada, o filtro e a rolagem da tabela
                   * continuam como estavam ao reabrir o painel.
                   */
                  display: painelAberto ? 'flex' : 'none',
                  flexDirection: 'column',
                  minHeight: 0, // necessário para overflow funcionar em flex
                }}
              >
                {/* Cabeçalho fixo no painel */}
                <div
                  style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    background: '#fff',
                    borderBottom: '1px solid #eee',
                    padding: '12px 12px 10px',
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gap: 8,
                  }}
                >
                  <Pagination
                    pageCount={totalPage}
                    initialData={currentPage}
                    onPageChange={(selected) => {
                      setCurrentPage(selected);
                    }}
                    location={{
                      catalogo: catalogo.idCatalogo,
                      pagina: paginaCatalogo ? paginaCatalogo.idPagina : 0,
                    }}
                  />
                  {paginaCatalogo && (
                    <>
                      <Form
                        ref={formRef}
                        id="editorForm"
                        onSubmit={handleConfirmar}
                      >
                        <Input id="caminho" name="caminho" isHidden />
                      </Form>

                      <Form ref={formPesqRef} autoComplete="off">
                        <Input
                          id="pesquisa"
                          name="pesquisa"
                          placeholder="Digite o item para pesquisar..."
                          onChange={handlePesquisar}
                          autoFocus
                        />
                      </Form>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: 8,
                        }}
                      >
                        <Switch
                          rigthText="Ocultar relacionados"
                          defaultChecked={linkedFiltro}
                          onChange={handleFiltrar}
                        />
                        {/* micro-resumo por conveniência */}
                        <div
                          style={{
                            fontSize: 10,
                            color: '#666',
                            display: 'flex',
                            gap: 10,
                          }}
                        >
                          <span
                            style={{
                              fontSize: 10,
                              background: '#eef7ff',
                              border: '1px solid #d6ebff',
                              padding: '4px 8px',
                              borderRadius: 6,
                            }}
                            title="Total de itens na página"
                          >
                            <b>{total}</b>
                          </span>
                          <span
                            style={{
                              fontSize: 10,
                              background: '#e8f8ef',
                              border: '1px solid #cdeedb',
                              padding: '4px 8px',
                              borderRadius: 6,
                            }}
                            title="Itens vinculados a links"
                          >
                            <b>{vinculados}</b>
                          </span>
                          <span
                            style={{
                              fontSize: 10,
                              background: '#fff4e5',
                              border: '1px solid #ffe5bf',
                              padding: '4px 8px',
                              borderRadius: 6,
                            }}
                            title="Itens ainda pendentes"
                          >
                            <b>{pendentes}</b>
                          </span>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Área rolável da tabela */}
                <div
                  style={{
                    flex: '1 1 auto',
                    overflow: 'auto',
                    padding: '8px 8px 12px',
                    minHeight: 0,
                    background: '#fff',
                  }}
                >
                  {paginaCatalogo && itensPagina && (
                    <EditorTable
                      ref={tableRef}
                      idCatalogo={id}
                      idPagina={paginaCatalogo.idPagina}
                      itensPagina={itensFiltro}
                      isDraggable
                      /** o painel desta tela tem altura definida */
                      alturaTotal
                      onLinkHighlight={(links, component) => {
                        handleHighlight(links, component);
                      }}
                      /** leva o desenho até o link do item clicado */
                      onGoToLink={(idItem) => {
                        if (editorRef.current && editorRef.current.irParaLink) {
                          editorRef.current.irParaLink(idItem);
                        }
                      }}
                      /**
                       * Item sem link: define como alvo do modo sequência,
                       * para o próximo arraste no desenho criar a área dele.
                       */
                      onSelectPending={(item) => {
                        if (
                          editorRef.current &&
                          editorRef.current.setItemSequencia
                        ) {
                          editorRef.current.setItemSequencia(item);
                        }
                      }}
                      /** sem permissão, a lixeira não é renderizada */
                      onExcluirItens={
                        podeExcluirItens ? handleExcluirItens : null
                      }
                    />
                  )}
                </div>
              </div>

              {/* Barra de redimensionamento (só faz sentido com o painel aberto) */}
              {painelAberto && (
                <div
                  role="separator"
                  aria-orientation="vertical"
                  title="Arraste para redimensionar"
                  onMouseDown={onStartResize}
                  style={{
                    width: 6,
                    cursor: 'col-resize',
                    background: isResizing
                      ? 'rgba(0,0,0,0.15)'
                      : 'rgba(0,0,0,0.06)',
                    transition: 'background 120ms ease',
                  }}
                />
              )}

              {/* Canvas (EditorArea) */}
              <div
                style={{
                  flex: '1 1 auto',
                  minWidth: 0,
                  /** o editor precisa da altura para esticar o desenho */
                  display: 'flex',
                  minHeight: 0,
                }}
              >
                <EditorArea
                  ref={editorRef}
                  pagina={paginaCatalogo}
                  itensPagina={itensPagina}
                  catalogo={catalogo}
                  onSave={handleSalvar}
                  onCancel={handleCancelar}
                  onBeforeOCR={() => setLoading(true)}
                  onAfterOCR={() => setLoading(false)}
                  onAssociate={(links) => {
                    handleLink(links);
                  }}
                  onLinkHighlight={(links, component) => {
                    handleHighlight(links, component);
                  }}
                />
              </div>
            </div>
          </EditorContainer.EditorArea>
        )}
      </EditorContainer.Wrapper>
    </EditorContainer>
  );
}

export default EditorAssociarAI;
